import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import type { YearAndMonthProductIds } from 'reactApp/modules/products/products.types';

// CLOUDWEB-19004
// Модалка Сейфа при очистке
const overquotaSafe: 'a' | 'b' | 'c' | undefined = !IS_BIZ_USER && !IS_ONPREMISE && getFeature('overquota-safe-ab');

export const overquotaSafeVariantB = overquotaSafe === 'b';
export const overquotaSafeVariantC = overquotaSafe === 'c';
export const isSafeEnabled = overquotaSafe === 'b' || overquotaSafe === 'c';
export const safeCheckIsEmpty: boolean = isSafeEnabled && isFeature('safe-check-is-empty');
export const safeShowDropdownButton: boolean = isSafeEnabled && isFeature('safe-show-dropdown-button');

const tariffIds = {
    month: ['W256G1m_single_quota_2022_cloud', 'W512G1m_single_quota_2022_cloud', 'W1T1m_single_quota_2022_cloud'],
    year: ['W256G1y_single_quota_2022_cloud', 'W512G1y_single_quota_2022_cloud', 'W1T1y_single_quota_2022_cloud'],
};

export const overquotaSafeTariffIds: YearAndMonthProductIds = getFeature('overquota-safe-tariffs') || tariffIds;

export const overquotaSafeTip: boolean | undefined =
    (overquotaSafeVariantB || overquotaSafeVariantC) && !IS_BIZ_USER && !IS_ONPREMISE && isFeature('overquota-safe-tip');
export const overquotaSafeTipEveryDay: boolean | undefined = !IS_BIZ_USER && !IS_ONPREMISE && isFeature('overquota-safe-tip-everay-day');

export const helpSafeHref = getFeature('safe-promo-help') || 'https://help.mail.ru/cloud_web/size/safe/';
